module.exports = __webpack_public_path__ + "90d98b5a4b4367b7ca50455d0bd69d8a.pdf";